import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo, getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cargarCatalogos_Otros, cargarCatalogosAsync, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf,generarReporteEnExcel} from '../../funciones_globales/interaccionApiReportes';
import moment from 'moment';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';

const COD_BOTON_SALDOCONTABLE = '090301';
const COD_BOTON_EXCEL = '090302';

class FormVent37  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaCorte: null,
            cliente_sel: null,
            vendedor_sel: null,
            zona_sel: null,
            opt_oficial_credito: [],
            oficial_credito_sel: null,
            tipoReporte: 'C',
            fechaDesde: null,
            fechaHasta: null,
        };

        this.imprimir = this.imprimir.bind(this);
        this.imprimirExcel = this.imprimirExcel.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 2 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    componentDidMount(){
        let usuario = getItemDatosSesion('usuario');
        let fechaProceso = getFechaProcesoPorModulo('04')
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta:fechaHasta})

        Promise.all([
            cargarCatalogos_Otros('CLI-OFICIALES'),
            cargarPermisoBoton(COD_BOTON_SALDOCONTABLE, usuario),
            cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
            this.props.generar_LogAuditoriaIngresoForm('0903')
        ])
        .then(([catalogoOficiales, configBotonSaldoContab,configBotonExcel ])=>{

            let isVisibleBotonSaldoContab = false;
            let isVisibleBotonExcel = false;

            if(configBotonSaldoContab.display==='block'){
                isVisibleBotonSaldoContab = true;
            }

            if(configBotonExcel.display==='block'){
                isVisibleBotonExcel = true;
            }
            this.setState({              
                opt_oficial_credito: catalogoOficiales,
                isVisibleBotonSaldoContab,
                isVisibleBotonExcel
            });
        })
        .catch((error)=>{
            alert(error);
        }) 
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0903');
    }

    imprimir(){
        try{            

            let reporte;
            let dataEnvio = {};
            
            reporte = 157;

            let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            dataEnvio.fechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
            dataEnvio.fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
            
           /* if(this.state.vendedor_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param4=${this.state.vendedor_sel.value}`;
                }
                dataEnvio.vendedor = this.state.vendedor_sel.value;
            }*/

           
                let config_request = {
                method: 'POST',
                url: '/ventatipocompravendedor',
                data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    visualizarReporteEnPdf(urlReporte);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    imprimirExcel(){
        try{            

            let reporte;
            let dataEnvio = {};
            
            reporte = 158;

            let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            dataEnvio.fechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
            dataEnvio.fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
            
           /* if(this.state.vendedor_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param4=${this.state.vendedor_sel.value}`;
                }
                dataEnvio.vendedor = this.state.vendedor_sel.value;
            }*/

           
                let config_request = {
                method: 'POST',
                url: '/ventatipocompravendedor',
                data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    generarReporteEnExcel(urlReporte);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04')
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        

        this.setState({            
            fechaCorte: moment(fechaProceso, 'DD/MM/YYYY'),            
            cliente_sel: null,
            vendedor_sel: null,
            zona_sel: null,
            oficial_credito_sel: null,
            tipoSaldo: 'CLI',
            tipoReporte: 'C',
            plazo:'30',
            fechaDesde: fechaDesde, fechaHasta: fechaHasta

        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Venta por Linea Vendedor</TituloForm>
                </HeaderForm>
                <CuerpoForm>

                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>  
                                <button type='button' className='btn btn-success btn-sm' onClick={this.imprimirExcel}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir EXCEL</button>  
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir PDF</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormVent37);